import type { FC, HTMLAttributes, MouseEvent } from 'react'
import styles from './backdrop.module.css'

export interface BackdropProps extends HTMLAttributes<HTMLDivElement> {
  open: boolean
  onClick?: (e: MouseEvent<HTMLDivElement>) => void
  invisible?: boolean
}

export const Backdrop: FC<BackdropProps> = ({ open, invisible, className, style, children, ...rest }) => {
  if (!open) {
    return null
  }

  const classes = [styles.backdrop, className].filter(Boolean).join(' ')

  return (
    <div
      className={classes}
      style={invisible ? { backgroundColor: 'transparent', ...style } : style}
      aria-hidden="true"
      {...rest}
    >
      {children}
    </div>
  )
}
